import $ from 'jquery';

function register(data) {
  import('./StateFilter' /* webpackChunkName: "StateFilter" */)
    .then(module => {
      new module.default(data);
    })
    .catch(error => {
      console.error(error);
    });
}

export {
  register,
};


// WEBPACK FOOTER //
// ./V7/tnew/lib/StateFilterRegistration.js